import React from 'react';
import { Link } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import logo from '../../image/logo.png';
import { history } from '../../redux/store';

export default class Logo extends React.Component {
  state = {
    toUrl: '/',
  };

  componentDidMount() {
    history.listen(this.updateUrl);
  }

  updateUrl = () => {
    Auth.currentSession().catch(e => this.setState({ toUrl: '/signin' }));
  };

  render() {
    const { collapsed } = this.props;

    return (
      <div className={`isoLogoWrapper ${collapsed ? "collapsed-logowrapper" : ""}`}>
        {collapsed ? (
          <div>
            <h3>
              <Link to={this.state.toUrl} style={{ overflow: 'hidden' }}>
                <img src={logo} alt='Resiliens' width={50} height={50} />
              </Link>
            </h3>
          </div>
        ) : (
          <h3 className='logo-with-text'>
            <Link to={this.state.toUrl}>
              {/* siteConfig.siteName */}
              <img src={logo} alt='Swasth' width={50} height={50} />
            </Link>
            <div>
              <h3 className='bold-text'>Resiliens</h3>
              <h5 className='para-text'>For Clinicians</h5>
            </div>
          </h3>
        )}
      </div>
    );
  }
}
